import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  Box: {
    minWidth: "80vw",
    margin: 25,
    minHeight: "400px",
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
      margin: 15,
      minHeight: "400px",
    }
  },
  Popover: {
    background: "rgba(0,0,0,0.2) !important",
    [theme.breakpoints.up("sm")]: {}
  },
  Screen: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      justifyContent: "space-between",
    }
  },
  img: {
    width: '60px',
    height: 38,
    marginLeft: 12,
    borderRadius: 8,
    border: `2px solid ${theme.palette.primary.main}`,
    [theme.breakpoints.up("sm")]: {
      width: 'auto',
      height: 40,
      m: 0,
    }
  },
  buttonFeedback: {
    marginBottom: '8em !important',
    bottom: 10,
    [theme.breakpoints.up("sm")]: {
      bottom: 10,
      marginBottom: '20px !important',
    },
  },
  feedbackButton: {
    position: "fixed !important",
    bottom: "24px !important",
    right: "24px !important",
    zIndex: "9999 !important",
    width: "56px !important",
    height: "56px !important",
    borderRadius: "50% !important",
    minWidth: "auto !important",
    boxShadow: "0 8px 24px rgba(0,0,0,0.15) !important",
    "&:hover": {
      boxShadow: "0 12px 32px rgba(0,0,0,0.2) !important",
      transform: "translateY(-2px) !important",
    },
    transition: "all 0.3s ease !important",
  }
}));

export default useStyles;